import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAppartement = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M30 5H10v30h20z"
    />
    <path
      fill="#00C5F2"
      d="M18 27h-5v8h5zM18 18h-5v5h5zM27 18h-5v5h5zM18 9h-5v5h5z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M24.5 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAppartement);

export default ForwardRef;
